import { ReactNode } from 'react';
import { LucideIcon, Inbox } from 'lucide-react';

export default function EmptyState({
  icon: Icon = Inbox, title, description, action,
}: {
  icon?: LucideIcon; title: string; description?: string; action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-14 px-6">
      <div className="flex items-center justify-center w-14 h-14 rounded-full bg-gray-100 text-gray-400 mb-4">
        <Icon size={26} strokeWidth={1.75} />
      </div>
      <p className="text-md font-semibold text-navy">{title}</p>
      {description && <p className="text-sm text-gray-500 mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
